import { Choice, Filter } from 'src/app/data/class';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-filter-dropdown',
    templateUrl: './filter-dropdown.component.html',
    styleUrls: ['./filter-dropdown.component.scss'],
    standalone: false
})
export class FilterDropdownComponent implements OnInit {

  @Input() section: any;
  @Input() filter: any;
  @Output() inputChangeEmitter: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    if (this.filter.value) {
      this.filter.selectedCount = 0;
      this.filter.choices.forEach((choice: Choice) => {
        if (this.filter.value.includes(choice[this.filter.nameProp])) {
          this.filter.selectedCount++;
          choice.state = true;
        }
      });
    }
  }

  toggleSelection(choice: Choice, filter: Filter): void {
    if (filter.singleSelection) {
      filter.choices.forEach((each: Choice) => {
        if (choice !== each) {
          each.state = false;
        }
      });
    }

    const prop = filter.valueProp ? filter.valueProp : (filter.nameProp ? filter.nameProp : 'value');
    if (filter.choices && filter.choices.length > 0) {
      const values = [];
      filter.choices.forEach((data) => {
        if (data.state) {
          values.push(data[prop]);
        }
      });
      filter.value = values;
      filter.selectedCount = values.length;
    }
    this.inputChangeEmitter.emit(filter.value);
  }

  clearAll(): void {
    this.filter.selectedCount = 0;
    this.filter.choices.forEach((choice: Choice) => {
      choice.state = false;
    });
  }
}
